import { FunctionComponent, PropsWithChildren, useContext, useEffect } from 'react';

import { AnalyticsDimensions, AnalyticsEvent, ScreenViewDimensions, logAnalyticsEvent } from '@vestico/utils';

import { RoutePathEnterBasicInfo, StepConfig } from '@vestico/shared';

import { ConfigContext } from '../WidgetEventsManager';

export interface LogMatchInfoAnalyticsProps extends PropsWithChildren {
  currentStepIndex: number;
  stepConfigs: StepConfig[];
}

export const LogMatchInfoAnalytics: FunctionComponent<LogMatchInfoAnalyticsProps> = ({ currentStepIndex, stepConfigs, children }) => {
  const { clientId } = useContext(ConfigContext);
  useEffect(() => {
    const logAnalytics = () => {
      const currentStepConfig = stepConfigs[currentStepIndex];

      if (!currentStepConfig) {
        return;
      }

      const screenViewParams: ScreenViewDimensions = {
        page_title: currentStepConfig.path,
        provider: clientId,
      };

      logAnalyticsEvent({ category: 'event', event: AnalyticsEvent.pageView, dimensions: screenViewParams });

      const analyticsParameters: AnalyticsDimensions = {
        provider: clientId,
      };

      if (currentStepConfig.path === RoutePathEnterBasicInfo) {
        logAnalyticsEvent({ category: 'event', event: AnalyticsEvent.bodyInfoBegin, dimensions: analyticsParameters });
      }
    };

    logAnalytics();
  }, [clientId, currentStepIndex, stepConfigs]);

  return <>{children}</>;
};
